import AddOnIconPath from "@ingka/ssr-icon/paths/add-on";

export default AddOnIconPath;
